/*
 * Personalización ("Make It Yours") - checkbox en product-options.liquid.
 * Al marcar el checkbox se revela un textarea (vía la lógica genérica de
 * .product-option__checkbox en theme.js) y se muestra este overlay sobre la
 * imagen del producto. Al escribir, el texto se refleja en vivo en el
 * overlay y se copia al input oculto properties[Engraving] que va con la línea
 * principal del carrito. No es un modal ni intercepta el Add to Cart.
 */
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.querySelector('[data-personalization-preview-wrap]');
  if (!wrap) return;

  var preview = wrap.querySelector('[data-personalization-preview]');
  var checkbox = document.querySelector('[data-personalization-checkbox]');
  var input = document.querySelector('[data-personalization-input]');
  var textProperty = document.getElementById('personalization-text-property');

  function updatePreviewText(value) {
    if (preview) preview.textContent = value;
  }

  function setEnabled(enabled) {
    wrap.hidden = !enabled;
    if (!enabled) {
      if (input) input.value = '';
      if (textProperty) textProperty.value = '';
      updatePreviewText('');
    }
  }

  // La cantidad del cargo de personalización sigue automáticamente a la
  // cantidad del llavero (2 llaveros grabados = line item de cargo en
  // cantidad 2 = 2x su precio). El selector +/- del cargo (heredado de
  // Gift Wrap/Box Engraving vía custom.js) sigue disponible para que el
  // cliente lo baje manualmente si no quiere grabar todas las unidades.
  var qtyInput = document.getElementById('product-option-quantity--personalization');
  function getMainQuantity() {
    var mainQtyInput = document.querySelector('[data-quantity-input]');
    return mainQtyInput ? (parseInt(mainQtyInput.value, 10) || 1) : 1;
  }
  function syncChargeQuantity() {
    if (!qtyInput) return;
    var mainQty = getMainQuantity();
    qtyInput.value = mainQty;
    qtyInput.setAttribute('max', mainQty);
  }

  if (checkbox) {
    checkbox.addEventListener('change', function () {
      setEnabled(checkbox.checked);
      if (checkbox.checked) syncChargeQuantity();
    });
  }

  if (qtyInput) {
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-quantity-input]')) syncChargeQuantity();
    });
    document.addEventListener('click', function (e) {
      if (e.target.matches('.js-qty__adjust')) setTimeout(syncChargeQuantity, 10);
    });
  }

  if (input) {
    input.addEventListener('input', function () {
      updatePreviewText(input.value);
      if (textProperty) textProperty.value = input.value.trim();
    });
  }
});
